import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=d7debefe&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7debefe')) {
      api.createRecord('d7debefe', component.options)
    } else {
      api.reload('d7debefe', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=d7debefe&", function () {
      api.rerender('d7debefe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Cw9q0kjUAE7z/JS/IncreaseNumber.vue"
export default component.exports